export const CloudPbxSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، مرکز تماس ابری، خط تلفن اینترنتی و پنل پیامکی و نرم‌افزار crm و فکس آنلاین.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-82800000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/cloud-pbx/#webpage",
      "url": "https://navatel.ir/products/cloud-pbx/",
      "name": "خرید مرکز تلفن ابری نواتل | بدون سخت‌افزار و محدودیت",
      "description": "مرکز تلفن ابری نواتل با اپلیکیشن اختصاصی، راه‌اندازی زیر ۴۸ ساعت، بدون نیاز به تجهیزات، یکپارچه با CRM و پشتیبانی ۲۴/۷.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/cloud-pbx/#service"
      },
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/cloud-pbx/#breadcrumb"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/cloud-pbx/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "مرکز تلفن ابری",
          "item": "https://navatel.ir/products/cloud-pbx/"
        }
      ]
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/products/cloud-pbx/#service",
      "name": "مرکز تلفن ابری نواتل",
      "alternateName": "سانترال ابری نواتل",
      "serviceType": "مرکز تلفن ابری / تلفن ابری (Cloud PBX / VoIP سازمانی)",
      "description": "مرکز تلفن ابری نواتل جایگزین سانترال سنتی است؛ بدون نیاز به سرور داخلی، سخت‌افزار یا نیروی متخصص، با اپلیکیشن اختصاصی روی موبایل، تبلت و کامپیوتر. امکاناتی مانند صف تماس، تلفن گویای هوشمند (IVR)، ضبط مکالمات، مانیتورینگ و گزارش‌گیری پیشرفته و یکپارچگی با CRM را در اختیار کسب‌وکارها قرار می‌دهد. راه‌اندازی زیر ۴۸ ساعت.",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Iran"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "کسب‌وکارها و سازمان‌ها (B2B)"
      },
      "url": "https://navatel.ir/products/cloud-pbx/",
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "پلن‌های اشتراک مرکز تلفن ابری نواتل (بر اساس نوع سرشماره و تعداد کاربر)",
        "itemListElement": [
          {
            "@type": "OfferCatalog",
            "name": "پلن‌ها با سرشماره اختصاصی ۹۱۶۹",
            "itemListElement": [
              {
                "@type": "AggregateOffer",
                "name": "بسته پایه - سرشماره ۹۱۶۹",
                "description": "شروع ارتباطات کسب‌وکار؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "1150000",
                "highPrice": "3600000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              },
              {
                "@type": "AggregateOffer",
                "name": "بسته عملیاتی - سرشماره ۹۱۶۹",
                "description": "مرکز تماس حرفه‌ای؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "1580000",
                "highPrice": "4480000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              },
              {
                "@type": "AggregateOffer",
                "name": "بسته یکپارچه - سرشماره ۹۱۶۹",
                "description": "همه کانال‌های ارتباطی در یک بستر؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "2150000",
                "highPrice": "6060000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              },
              {
                "@type": "AggregateOffer",
                "name": "بسته فراگیر - سرشماره ۹۱۶۹",
                "description": "کامل‌ترین راهکار ارتباط با مشتری؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "2690000",
                "highPrice": "8570000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              }
            ]
          },
          {
            "@type": "OfferCatalog",
            "name": "پلن‌ها با سرشماره‌های اختصاصی ۸۲۸۰، ۸۱۶۴ و ۸۷۲۱",
            "itemListElement": [
              {
                "@type": "AggregateOffer",
                "name": "بسته پایه - سرشماره ۸۲۸۰/۸۱۶۴/۸۷۲۱",
                "description": "شروع ارتباطات کسب‌وکار؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "1620000",
                "highPrice": "4380000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              },
              {
                "@type": "AggregateOffer",
                "name": "بسته عملیاتی - سرشماره ۸۲۸۰/۸۱۶۴/۸۷۲۱",
                "description": "مرکز تماس حرفه‌ای؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "2160000",
                "highPrice": "5260000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              },
              {
                "@type": "AggregateOffer",
                "name": "بسته یکپارچه - سرشماره ۸۲۸۰/۸۱۶۴/۸۷۲۱",
                "description": "همه کانال‌های ارتباطی در یک بستر؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "2740000",
                "highPrice": "6840000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              },
              {
                "@type": "AggregateOffer",
                "name": "بسته فراگیر - سرشماره ۸۲۸۰/۸۱۶۴/۸۷۲۱",
                "description": "کامل‌ترین راهکار ارتباط با مشتری؛ قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
                "url": "https://navatel.ir/products/cloud-pbx/",
                "priceCurrency": "IRR",
                "lowPrice": "3290000",
                "highPrice": "8850000",
                "offerCount": "2",
                "eligibleQuantity": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 300,
                  "unitText": "کاربر"
                }
              }
            ]
          }
        ]
      },
      "hoursAvailable": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Saturday","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      }
    }
  ]
}